import { cn } from "@newxsystems/shared";
import { DaylightAction } from "../DaylightAction/DaylightAction";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import { DaylightRichText } from "../DaylightRichText/DaylightRichText";
import type { IHeroBackgroundImageProps } from "./HeroBackgroundImage.props";

export const HeroBackgroundImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroBackgroundImageProps) => {
  const centered = alignment === "center";
  return (
    <div className="relative flex min-h-[38rem] overflow-hidden border border-border bg-terminal md:min-h-[46rem]">
      <DaylightMedia
        className="absolute inset-0 h-full border-0"
        imageClassName="object-cover"
        media={image.image}
        priority
        sizes="(min-width: 1600px) 1520px, calc(100vw - 80px)"
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-linear-to-t from-terminal via-terminal/45 to-terminal/10"
      />
      <div className="relative z-10 flex w-full items-end p-7 md:p-12 lg:p-16">
        <div
          className={cn(
            "flex w-full max-w-[64rem] flex-col gap-6 border-t border-primary pt-8",
            centered && "mx-auto items-center text-center",
          )}
        >
          {eyebrow ? <p className="daylight-label text-primary">{eyebrow}</p> : null}
          {heading ? (
            <h1 className="max-w-[14ch] font-daylight-display text-[clamp(3.25rem,9.6vw,12rem)] font-bold leading-[0.85] tracking-[-0.04em] text-balance text-graphite">
              {heading}
            </h1>
          ) : null}
          {description ? (
            <DaylightRichText className="max-w-[60ch] text-lg text-graphite/85" content={description} />
          ) : null}
          {buttons?.length ? (
            <div className={cn("flex flex-wrap gap-3 pt-2", centered && "justify-center")}>
              {buttons.map((button, index) => (
                <DaylightAction action={button} key={`${button.href}-${index}`} />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

HeroBackgroundImage.displayName = "Content::HeroBackgroundImage";
